import React from 'react';

import './StoryHolder.scss';

import Story from '../Story/Story';
import VideoIntro from '../VideoIntro/VideoIntro';

const StoryHolder = ({ videoIntroData, isInline, size, topOffset }) => {
  return (
    <>
      <VideoIntro cardData={videoIntroData} isInline={isInline} size={size} topOffset={topOffset} />
      <Story homeData={videoIntroData} isInline={isInline} topOffset={topOffset} />
    </>
  );
};

export default StoryHolder;
